import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import Layout from './components/Layout';
import Statistics from './components/EntityTypeList';
import EntityList from './components/EntityList';
import EntityDetails from './components/EntityDetails';
import CaseStudy from './components/CaseStudy';
import TopicPage from './components/TopicPage';
import About from './components/About';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

// Configure future flags for React Router v7 compatibility
const routerOptions = {
  future: {
    v7_startTransition: true,
    v7_relativeSplatPath: true
  }
};

function App() {
  console.log('App mounting');
  return (
    <QueryClientProvider client={queryClient}>
      <Router {...routerOptions}>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Statistics />} />
            <Route path="type/:type" element={<EntityList />} />
            <Route path="type/:type/entity/:entity" element={<EntityDetails />} />
            <Route path="case-study/:author" element={<CaseStudy />} />
            <Route path="topic/:topic" element={<TopicPage />} />
            <Route path="about" element={<About />} />
          </Route>
        </Routes>
      </Router>
    </QueryClientProvider>
  );
}

export default App;